import {useLocalStorage} from '@aboutyou/storage';
import {useFullSession} from '@aboutyou/user';
import {useCallback} from 'react';

const UNLOCKED_COUPON_TOKENS_KEY = 'unlocked-coupon-tokens';

export const useUnlockedCouponTokens = () => {
  const [unlockedCouponTokens, setUnlockedCouponTokens] = useLocalStorage<
    string[]
  >({
    key: UNLOCKED_COUPON_TOKENS_KEY,
    defaultValue: [],
    forcePersistValue_ILLEGALLY: true, // we are allowed to store this value even if the user has not accepted the cookie banner
  });

  const fullSession = useFullSession();

  const addToUnlockedCouponTokens = useCallback(
    ({couponToken, paused}: {couponToken: string; paused: boolean}) => {
      const uniqueTokens = unlockedCouponTokens
        ? new Set([couponToken, ...unlockedCouponTokens])
        : new Set([couponToken]);

      // if paused, we store the unlocked coupon tokens in the local storage but do not update the state so that the requests which depend on the "ReductionsState" do not get triggered
      if (paused) {
        updateSavedCouponsWithoutTriggeringRefetch(Array.from(uniqueTokens));
      } else {
        setUnlockedCouponTokens(Array.from(uniqueTokens));
      }
    },
    [setUnlockedCouponTokens, unlockedCouponTokens],
  );

  return {
    unlockedCouponTokens:
      fullSession && unlockedCouponTokens?.length
        ? unlockedCouponTokens
        : undefined,
    addToUnlockedCouponTokens,
  };
};

export const updateSavedCouponsWithoutTriggeringRefetch = (
  tokens: string[],
) => {
  localStorage?.setItem(UNLOCKED_COUPON_TOKENS_KEY, JSON.stringify(tokens));
};
